import { menuListItems } from 'assets/menu/menuList';
import { BreadCrumb } from 'components/BreadCrumb';
import { GoToBack } from 'components/GoToBack';
import { Header } from 'components/Header';
import { Menu } from 'components/Menu';
import React from 'react';
import { useParams } from 'react-router-dom';

import { HeaderContainer } from './styles';
import { ExhibitorForm } from '../ExhibitorForm';

export const ExhibitorEdit: React.FC = () => { 
  const { eventId, exhibitorId } = useParams<{ eventId: string; exhibitorId: string }>();

  return (
    <Menu links={menuListItems}>
      <Header>
        <HeaderContainer>
          <div>
            <GoToBack />
          </div>

          <div className="header-text">
            <BreadCrumb 
              itens={["Eventos", "Detalhes", "Editar Expositor"]} 
              itemActive="Editar Expositor" 
            />
          </div>
        </HeaderContainer>
      </Header>

      <ExhibitorForm eventId={eventId} exhibitorId={exhibitorId} />
      
    </Menu>
  );
} 